import React from 'react';
import { FaFacebook, FaTwitter, FaInstagram } from 'react-icons/fa';
import { motion } from "framer-motion";

import './Footer.css'; 

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section about">
          <h3>À propos de nous</h3>
          <p>
            Bienvenue à l'Hôtel Syphax, où élégance et confort se rencontrent pour vous offrir une expérience inoubliable.
          </p>
        </div>
        <div className="footer-section links">
          <h3>Liens utiles</h3>
          <ul>
            <li><a href="/">Accueil</a></li>
            <li><a href="/Reservation">Reservation</a></li>
            <li><a href="/chambres">Chambres</a></li>
            <li><a href="/services">Services</a></li>
            <li><a href="/gallerie">Gallerie</a></li>
            <li><a href="/contact">Contact</a></li>
          </ul>
        </div>
        <div className="footer-section contact">
          <h3>Contactez-nous</h3>
        <p>Adresse : Route Nationale N 09-Tichy-Bejaia</p>
          <p>Téléphone : 034.81.67.04</p>
          <p>Email : hotelsyphax1@gmail.com</p>
          <div className="social-links">
          <a href="https://facebook.com" aria-label="Facebook">
            <FaFacebook />
          </a>
          <a href="https://twitter.com" aria-label="Twitter">
            <FaTwitter />
          </a>
          <a href="https://instagram.com" aria-label="Instagram">
            <FaInstagram />
          </a>
        </div>
        </div>
     
      </div>
      <div className="footer-bottom">
        &copy; {new Date().getFullYear()} © 2025 Hôtel Syphax. Développé par Meriem LEBRACHE & Nour El Houda LACHI. Tous droits réservés.
      </div>
    </footer>
  );
}

export default Footer;